export default __webpack_public_path__ + "static/media/hair-style.ec256e32.jpg";